import { render, staticRenderFns } from "./ArticleMain.vue?vue&type=template&id=6c09ad30&scoped=true&"
import script from "./ArticleMain.vue?vue&type=script&lang=js&"
export * from "./ArticleMain.vue?vue&type=script&lang=js&"
import style0 from "./ArticleMain.vue?vue&type=style&index=0&id=6c09ad30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c09ad30",
  null
  
)

export default component.exports